import { configureStore } from '@reduxjs/toolkit'
import appReducer from './slices/appSlice.ts'
import userReducer from './slices/userSlice.ts'
import generationReducer from './slices/generationSlice.ts'
import presetsReducer from './slices/presetsSlice.ts'

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    generation: generationReducer,
    presets: presetsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['app.viewport', 'user.user', 'app.theme'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
